<div class="flex-col flex">
    <mat-expansion-panel class="mat-elevation-z cb-margin-bottom" expanded="true">
        <mat-expansion-panel-header>
            <mat-panel-title class="cb-grey">
                <mat-icon>announcement</mat-icon>
                &nbsp;
                <b>Alerts</b>
            </mat-panel-title>
        </mat-expansion-panel-header>
        @if (hasAbmCodeAlert()) {
            <div class="alert-message warn">
                <mat-icon>warning</mat-icon>
                <span>ABM Code Required By Finance</span>
            </div>
        }
        @if (!account.isClosedOrDeclined() &&
        !account.ordersContactExistsOnAccount &&
        !account.isRatesOnly) {
            <div class="alert-message warn">
                <mat-icon>warning</mat-icon>
                <span>Orders Contact Required</span>
            </div>
        }
        @if (!account.isClosedOrDeclined() && !account.creditorsContactExistsOnAccount) {
            <div class="alert-message warn">
                <mat-icon>warning</mat-icon>
                <span>Accounts Contact Required</span>
            </div>
        }
        @if (!account.isClosedOrDeclined() && !account.allRequiredDocumentsUploaded) {
            <div class="alert-message warn">
                <mat-icon>warning</mat-icon>
                <span>Document Upload Required</span>
            </div>
        }
        @if (!account.isClosedOrDeclined() && account.anyDocumentRequiresReview) {
            <div class="alert-message warn">
                <mat-icon>warning</mat-icon>
                <span>Document Review Required</span>
            </div>
        }
        @if (account.status === BUSINESS_ACCOUNT_STATUS_ENUM.Closed) {
            <div class="alert-message">
                <mat-icon>info_outline</mat-icon>
                <span>Account Closed</span>
            </div>
        }
        @if (account.status === BUSINESS_ACCOUNT_STATUS_ENUM.Declined) {
            <div class="alert-message error">
                <mat-icon>error</mat-icon>
                <span>Account Declined</span>
            </div>
        }
        @if (account.status === BUSINESS_ACCOUNT_STATUS_ENUM.RequestCancelled) {
            <div class="alert-message">
                <mat-icon>info_outline</mat-icon>
                <span>Request Cancelled</span>
            </div>
        }
        @if (account.status === BUSINESS_ACCOUNT_STATUS_ENUM.RequestDeclined) {
            <div class="alert-message error">
                <mat-icon>error</mat-icon>
                <span>Request Declined</span>
            </div>
        }
        @if (account.status === BUSINESS_ACCOUNT_STATUS_ENUM.OnHold) {
            <div class="alert-message error">
                <mat-icon>error</mat-icon>
                <span>Account On Hold</span>
            </div>
        }
    </mat-expansion-panel>
    <hr class="mat-divider cb-margin-bottom" />
    <mat-expansion-panel class="mat-elevation-z cb-margin-bottom" expanded="true">
        <mat-expansion-panel-header>
            <mat-panel-title class="cb-grey">
                <mat-icon>assignment</mat-icon>
                &nbsp;
                <b>Account Approval</b>
            </mat-panel-title>
        </mat-expansion-panel-header>
        <div class="flex-col" #requestApproval>
            <span class="mat-subtitle-1">Account Request</span>
            <div class="cb-padding-left flex-col">
                @if (canSubmitAccount()) {
                    <button mat-stroked-button color="accent" (click)="onSubmitAccountClicked()">
                        Submit Account For Approval
                    </button>
                }
                @if (canSubmitRequest()) {
                    <button mat-stroked-button color="accent" (click)="onSubmitRequestClicked()">
                        Submit Request For Approval
                    </button>
                }
                @if (canCancelRequest()) {
                    <button mat-stroked-button color="warn" (click)="onCancelRequestClicked()">
                        Cancel Account Request
                    </button>
                }
                <cb-user-date-time-new
                    [label]="'Requested By'"
                    [userFullName]="account.requestedBy"
                    [date]="account.requestedDate"
                    [displayTime]="true"
                    [floatingLabel]="true"
                ></cb-user-date-time-new>
                @if (account.requestCancelledByUser) {
                    <cb-user-date-time-new
                        [label]="'Request Cancelled By'"
                        [userFullName]="account.requestCancelledByUser"
                        [date]="account.requestCancelledDate"
                        [displayTime]="true"
                        [floatingLabel]="true"
                    ></cb-user-date-time-new>
                }
            </div>
        </div>
        <div class="flex-col" #requestApproval>
            <span class="mat-subtitle-1">Request Approval</span>
            <div class="cb-padding-left flex-col">
                @if (canApproveRequest()) {
                    <div class="flex-row">
                        <button
                            mat-stroked-button
                            color="accent"
                            (click)="onApproveRequestClicked()"
                        >
                            <mat-icon>check_circle</mat-icon>
                            &nbsp;Approve Request
                        </button>
                        <span class="flex"></span>
                        <button mat-stroked-button color="warn" (click)="onDeclineRequestClicked()">
                            <mat-icon class="cb-error">cancel</mat-icon>
                            &nbsp;Decline Request
                        </button>
                    </div>
                }
                @if (account.requestApprovedByUser) {
                    <cb-user-date-time-new
                        [label]="'Approved By'"
                        [userFullName]="account.requestApprovedByUser"
                        [date]="account.requestApprovedDate"
                        [displayTime]="true"
                        [floatingLabel]="true"
                    ></cb-user-date-time-new>
                }
                @if (account.requestDeclinedByUser) {
                    <cb-user-date-time-new
                        [label]="'Declined By'"
                        [userFullName]="account.requestDeclinedByUser"
                        [date]="account.requestDeclinedDate"
                        [displayTime]="true"
                        [floatingLabel]="true"
                    ></cb-user-date-time-new>
                }
                @if (account.requestDeclinedByUser) {
                    <cb-text-area
                        label="Declined Reason"
                        name="requestDeclinedReason"
                        [ngModel]="account.requestDeclinedReason"
                        [readonly]="true"
                    ></cb-text-area>
                }
            </div>
        </div>
        <div class="flex-col" #contractApproval>
            <span class="mat-subtitle-1">Contract Approval</span>
            <div class="cb-padding-left flex-col">
                @if (canApproveContract()) {
                    <div class="flex-row">
                        <button
                            mat-stroked-button
                            color="accent"
                            (click)="onApproveContractClicked()"
                        >
                            <mat-icon>check_circle</mat-icon>
                            &nbsp;Approve
                        </button>
                        <span class="flex"></span>
                        <button
                            mat-stroked-button
                            color="warn"
                            (click)="onDeclineContractClicked()"
                        >
                            <mat-icon class="cb-error">cancel</mat-icon>
                            &nbsp;Decline
                        </button>
                    </div>
                }
                @if (account.approvedByProcurementUser) {
                    <cb-user-date-time-new
                        [label]="'Approved By'"
                        [userFullName]="account.approvedByProcurementUser"
                        [date]="account.approvedByProcurementDate"
                        [displayTime]="true"
                        [floatingLabel]="true"
                    ></cb-user-date-time-new>
                }
                @if (account.declinedByUser) {
                    <cb-user-date-time-new
                        [label]="'Declined By'"
                        [userFullName]="account.declinedByUser"
                        [date]="account.declinedDate"
                        [displayTime]="true"
                        [floatingLabel]="true"
                    ></cb-user-date-time-new>
                }
                @if (account.declinedByUser) {
                    <cb-text-area
                        label="Declined Reason"
                        name="declinedReason"
                        [ngModel]="account.declinedReason"
                        [readonly]="true"
                    ></cb-text-area>
                }
            </div>
        </div>
        <div class="flex-col" #healthApproval>
            <span class="mat-subtitle-1">Health &amp; Safety Approval</span>
            <div class="cb-padding-left flex-col">
                @if (canApproveHealthAndSafety()) {
                    <div class="flex-row">
                        <button
                            mat-stroked-button
                            color="accent"
                            (click)="onApproveHealthAndSafetyClicked()"
                        >
                            <mat-icon>check_circle</mat-icon>
                            &nbsp;Approve
                        </button>
                        <span class="flex"></span>
                        <button
                            mat-stroked-button
                            color="warn"
                            (click)="onDeclineHealthAndSafetyClicked()"
                        >
                            <mat-icon class="cb-error">cancel</mat-icon>
                            &nbsp;Decline
                        </button>
                    </div>
                }
                @if (account.approvedByHealthAndSafetyUser) {
                    <cb-user-date-time-new
                        [label]="'Approved By'"
                        [userFullName]="account.approvedByHealthAndSafetyUser"
                        [date]="account.approvedByHealthAndSafetyDate"
                        [displayTime]="true"
                        [floatingLabel]="true"
                    ></cb-user-date-time-new>
                }
                @if (account.healthandSafetyRequestDeclinedByUser) {
                    <cb-user-date-time-new
                        [label]="'Declined By'"
                        [userFullName]="account.healthandSafetyRequestDeclinedByUser"
                        [date]="account.healthandSafetyRequestDeclinedDate"
                        [displayTime]="true"
                        [floatingLabel]="true"
                    ></cb-user-date-time-new>
                }
                @if (account.healthandSafetyRequestDeclinedByUser) {
                    <cb-text-area
                        label="Declined Reason"
                        name="healthandSafetyRequestDeclinedReason"
                        [ngModel]="account.healthandSafetyRequestDeclinedReason"
                        [readonly]="true"
                    ></cb-text-area>
                }
            </div>
        </div>
        @if (hasApprovalOverride()) {
            <div class="flex-col" #overrideApproval>
                <span class="mat-subtitle-1">Approval Override</span>
                <div class="cb-padding-left flex-col">
                    @if (canRequestApprovalOverride()) {
                        <button
                            mat-stroked-button
                            color="accent"
                            (click)="onRequestApprovalOverrideClicked()"
                        >
                            <mat-icon>warning</mat-icon>
                            &nbsp;Request Override
                        </button>
                    }
                    @if (account.approvalOverrideRequest) {
                        <cb-user-date-time-new
                            [label]="'Requested By'"
                            [userFullName]="account.approvalOverrideRequest.requestedBy"
                            [date]="account.approvalOverrideRequest.requestedDate"
                            [displayTime]="true"
                            [floatingLabel]="true"
                        ></cb-user-date-time-new>
                    }
                    @if (account.approvalOverrideRequest) {
                        <cb-text-area
                            label="Approval Override Reason"
                            name="approvalOverrideRequestDescription"
                            [ngModel]="account.approvalOverrideRequest.description"
                            [readonly]="true"
                        ></cb-text-area>
                    }
                    @if (canApproveOverrideRequests()) {
                        <div class="flex-row">
                            <cb-button
                                [disabled]="!account.abmCode"
                                (clicked)="onApproveOverrideClicked()"
                                (popupClick)="editFinanceInformationClicked.emit()"
                                color="accent"
                                [isStroked]="true"
                                [popup]="{
                        description:
                            'Override can NOT be completed until an ABM Code has been loaded by the Finance Team.',
                        buttonText: 'Edit Finance Information',
                        disabled: !this.account.canEditFinanceInformation() || !this.permissions.canEditFinanceInformation()
                    }"
                            >
                                <mat-icon style="font-size:16px" class="start-center">check_circle</mat-icon>
                                Approve Override
                            </cb-button>

                            <button
                                mat-stroked-button
                                class="button-custom-disable"
                                [ngClass]="
                                    !account.abmCode ? 'cb-margin-left-4x' : 'cb-margin-left-2x'
                                "
                                color="warn"
                                [disabled]="!account.abmCode"
                                (click)="onDeclineOverrideClicked()"
                            >
                                <mat-icon>cancel</mat-icon>
                                &nbsp;Decline Override
                            </button>
                        </div>
                    }

                    @if (account.approvalOverrideRequest &&
                    account.approvalOverrideRequest.processedBy) {
                        <cb-user-date-time-new
                            [label]="
                                BUSINESS_ACCOUNT_APPROVAL_OVERRIDE_REQUEST_OUTCOME_ENUM[
                                    account.approvalOverrideRequest.outcome
                                ] + ' By'
                            "
                            [userFullName]="account.approvalOverrideRequest.processedBy"
                            [date]="account.approvalOverrideRequest.processedDate"
                            [displayTime]="true"
                            [floatingLabel]="true"
                        ></cb-user-date-time-new>
                    }
                </div>
            </div>
        }
    </mat-expansion-panel>
</div>
